export default ({...props}) => {
  const {primaryButton, secondaryButton, size, space, themeGrey, fontWeight, rem} =
    props.theme
  const {normal} = fontWeight

  return `
        box-shadow: none;
        font-weight: ${normal};
        font-size: ${rem(1.0625)};
        letter-spacing: ${space(-0.03875)}px;
        margin-bottom: 0px;
        display:flex;
        height: ${size(4.25)}px;
        & > span.text-elipsis {
            overflow: hidden;
            white-space: nowrap;
            display: block;
            text-overflow: ellipsis;
        }
        // primary buttons get lighter upon hover/interaction
        &[ap_type="primary"]{
            color: ${primaryButton.foreground};
            background-color: ${primaryButton.background};
            border: 1px solid;
            border-color: ${primaryButton.border};

            &:hover{
                box-shadow: none;
                background-color:${primaryButton.background}80;
            }
            &:focus {
                background-color: ${primaryButton.background};
                .MuiTouchRipple-root > * {
                    & > *{
                        filter: contrast(5%) brightness(195%);
                    }
                }
            }
            &[disabled]{
                background-color: ${themeGrey.input_disabled};
                color: ${themeGrey.disabled_grey};
                border-color: ${themeGrey.input_disabled};
            }
        }
        // secondary buttons get darker upon hover/interaction
        &[ap_type="secondary"]{
            color: ${secondaryButton.foreground};
            background-color: ${secondaryButton.background};
            border-color: ${secondaryButton.border};

            &:hover {
                filter: brightness(97.5%)
            }

            &:focus {
                background-color: ${secondaryButton.background};
                .MuiTouchRipple-root > * {
                    & > *{
                        filter: contrast(5%) brightness(97.5%);
                    }
                }
            }
            
            &[disabled]{
                background-color: ${themeGrey.input_disabled};
                color: ${themeGrey.disabled_grey};
                border-color: ${themeGrey.input_disabled};
            }
        }
    `
}
